<template>
  <div class="col-xl-4 col-sm-6 mb-xl-0 mb-4">
    <div class="card" v-loading="loading">
      <div class="card-body p-3">
        <h6 class="card-title">{{ title }}</h6>
        <div class="row">
          <div class="col-9">
            <div class="numbers">
              <p class="text-sm mb-0 font-weight-bold">
                <AuditPendenciesValueMoreForm ref="form" :tableData="tableData" />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom clearfix">
        <el-button type="success" plain class="w-100" @click="apply()">{{
          $t("aplicar")
        }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { AuditService } from "@/services/customers/audit.services";
import AuditPendenciesValueMoreForm from './AuditPendenciesValueMoreForm';

export default {
  name: "AuditPendenciesValueMoreCard",
  props: ["title"],
  components: {
    AuditPendenciesValueMoreForm,
  },
  data() {
    return {
      visible: false,
      loading: true,
      tableData: [],
      stage: '',
      type: '',
    }
  },
  methods: {
    show(method, type) {
      const vm = this;
      vm.visible = true;
      vm.loading = true;
      vm.state = method;
      vm.type = type;
      setTimeout(() => {
        AuditService[method](type)
          .then((response) => {
            vm.tableData = response;
          })
          .catch((error) => {
            vm.$message({ type: "error", message: error });
          })
          .finally(() => vm.loading = false);

      }, 200);
    },
    hide() {
      this.visible = false;
    },
    apply() {
      const vm = this;
      const form = vm.$refs.form.get();
      if (!form.service) {
        return vm.$message({ type: "error", message: 'É preciso selecionar o item código!' });
      }
      if (!form.type) {
        return vm.$message({ type: "error", message: 'É preciso selecionar o tipo de utilização do valor!' });
      }
      if (form.type === '2' && (+form.spred <= 0 || isNaN(+form.spred))) {
        return vm.$message({ type: "error", message: 'Valor de Spred é inválido, ele deve ser superior a 0!' });
      }
      const loading = vm.$loading(vm.$options.loading);
      AuditService.values(vm.state, vm.type, form)
        .then((response) => {
          vm.$message({ type: "success", message: 'Valor atualizado nas pendências de auditoria!' });
          vm.$emit('reload');
          vm.visible = false;
        })
        .catch((error) => {
          vm.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
    },
  },
};
</script>
<style scoped>
.list-group-item {
  padding-top: 15px !important;
}
</style>